import React, { useEffect, useState } from 'react';
import './ClassicSBEvents.scss';

interface ClassicSBOddsBoxProps {
    price: number;
    runnerId: string;
    isSuspendedOrClosed: boolean;
}

const ClassicSBOddsBox: React.FC<ClassicSBOddsBoxProps> = ({ price, runnerId, isSuspendedOrClosed }) => {
    const [classes, setClasses] = useState<string>('');
    const [currentValue, setCurrentValue] = useState<number>(0);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (timer) clearTimeout(timer);
        if (Number.isFinite(price)) {
            const newTimer = setTimeout(() => {
                setClasses("");
            }, 5000);
            setTimer(newTimer);

            if (currentValue && price !== currentValue) {
                const newClass = currentValue < price ? "runner-up" : "runner-down";
                let count = 0;
                const interval = setInterval(() => {
                    setClasses(prev => prev ? "" : newClass);
                    count++;
                    if (count >= 6) clearInterval(interval);
                }, 500);
            }
            setCurrentValue(price);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [price]);

    return (
        <div className={`odd-box ${classes}`}>
            {isSuspendedOrClosed || !Number.isFinite(price) ? '-' : price.toFixed(2)}
        </div>
    );
};

export default ClassicSBOddsBox; 